import styled from "styled-components";

const Container = styled.div<{
  colour?: string;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-size: 13px;
  font-weight: 700;
  color: ${({ colour }) => colour};
`;

const Line = styled.div<{
  colour?: string;
}>`
  flex-grow: 1;
  border-top: 1px solid ${({ colour }) => colour};
  color: inherit;
`;

export type DividerProps = {
  children?: string;
  styles?: {
    OverallGeneralTextColour?: string;
  };
  dataId?: string;
};

export const Divider: React.FC<DividerProps> = ({
  children,
  styles = { OverallGeneralTextColour: "#202227" },
  dataId,
}) => {
  return (
    <Container colour={styles.OverallGeneralTextColour} data-id={dataId}>
      <Line colour={styles.OverallGeneralTextColour} />
      {children}
      <Line colour={styles.OverallGeneralTextColour} />
    </Container>
  );
};

export default Divider;
